export default "__VITE_ASSET__0e2df60f__"